import blankPortraitBox from 'assets/images/blank-portrait-box.png';
import blankStand from 'assets/images/blank-stand.png';
import blankDisc from 'assets/images/blank-disc.png';

export default async function VesselImage(selectedVessel) {
    let updatedVesselImage = null;
    await fetch('../fpc_config.json')
        .then((r) => r.json())
        .then((data) => {
            const selectedConfig = data.Config_File.find((x) => x.SugarID === selectedVessel);
            if (!selectedConfig) {
                return;
            }

            switch (selectedConfig.Vessel_Image) {
                case '1':
                    updatedVesselImage = blankPortraitBox;
                    break;
                case '2':
                    updatedVesselImage = blankStand;
                    break;
                case '3':
                    updatedVesselImage = blankDisc;
                    break;
                default: // 0
                    updatedVesselImage = null;
                    break;
            }
        });

    return updatedVesselImage;
}
